import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/lib/theme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const Icon = theme === 'dark' ? Sun : Moon;
  const label = theme === 'dark' ? 'Schakel naar licht' : 'Schakel naar donker';
  return (
    <button
      type="button"
      onClick={toggle}
      title={label}
      aria-label={label}
      className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-bmade-200 text-bmade-700 transition-colors hover:border-bmade-400 hover:bg-bmade-100 dark:border-bmade-800 dark:text-bmade-300 dark:hover:border-bmade-600 dark:hover:bg-bmade-800"
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}
